export const FETCH_COUNTRIES_PENDING = 'FETCH_COUNTRIES_PENDING';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_COUNTRIES_ERROR = 'FETCH_COUNTRIES_ERROR';
export const FILTER_COUNTRIES = 'FILTER_COUNTRIES';
export const SET_CURRENT_COUNTRY = 'SET_CURRENT_COUNTRY';